import { createElement, removeElement} from '../utils/domManager';
import '../polyfills/fullscreen';

/**
 * Full screen button component
 * @returns {Object}
 */
const fullScreenButton = (options) => {
    const domElement = createElement('div', { title: options.fullScreenButton.title, className: 'top-right-button'});
    const iconElement = createElement('svg', { viewBox: '0 0 12 12', class: 'top-right-button-icon' });

    setIcon();

    /**
     * Sets icon element styles and content
     */
    function setIcon() {
        iconElement.innerHTML = `<path d="M11.25 5.42578L9.33594 3.48438L3.48438 9.33594L5.42578 11.25H0.75V6.57422L2.66406
            8.51562L8.51562 2.66406L6.57422 0.75H11.25V5.42578Z" fill="#4A4A4A"/></svg>`;
    }

    function onDomElementClick(containerElement) {
        // If there's an element in fullscreen, exit
        // Otherwise, enter it
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            containerElement.requestFullscreen();
        }
    }

    function onContainerMouseEnter() {
        domElement.style.display = 'flex';
    }

    function onContainerMouseLeave() {
        domElement.style.display = 'none';
    }

    function addListeners(containerElement) {
        domElement.addEventListener('click', () => onDomElementClick(containerElement));
        containerElement.addEventListener('mouseenter', onContainerMouseEnter);
        containerElement.addEventListener('mouseleave', onContainerMouseLeave);
    }

    function removeListeners(containerElement) {
        domElement.removeEventListener('click', () => onDomElementClick(containerElement));
        containerElement.removeEventListener('mouseenter', onContainerMouseEnter);
        containerElement.removeEventListener('mouseleave', onContainerMouseLeave);
    }

    /**
     * Appends button (and icon) element in DOM and creates listeners
     */
    function render(containerElement) {
        containerElement.style.position = 'relative';
        containerElement.appendChild(domElement);
        domElement.appendChild(iconElement);
        addListeners(containerElement);
    }

    function remove(containerElement) {
        removeElement(containerElement, domElement);
        removeListeners(containerElement);
    }

    return {
        render,
        remove
    };
};

export default fullScreenButton;
